import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import cx from 'classnames';
// import {
//   Button, Modal,
//   Slider, Radio,
// } from 'antd';
// import { EditorElementPopover } from '../EditorElementPopover';


export class PContainer extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string, // bgLight (default) | bgDark | bgLightAlt | bgDarkAlt
    className: PropTypes.string,
    style: PropTypes.object,

    colorScheme: PropTypes.object,
    children: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    publish: PropTypes.bool,
  };

  static defaultProps = {
    backgroundColor: 'bgLight',
    publish: false,
  };

  getSolidColor = (c) => {
    const { colorScheme } = this.props;
    const color = (typeof c === 'undefined') ? 'bgLight' : c;
    return colorScheme[color];
  };

  render() {
    const { backgroundColor, publish, style, className } = this.props;

    const styleInEditor = publish ? {} : {
      backgroundColor: this.getSolidColor(backgroundColor),
    };

    return (
      <div
        className={cx(
          className,
          `bgcolor-${backgroundColor}`
        )}
        style={{
          ...style,
          ...styleInEditor,
        }}
      >
        { this.props.children }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/elements/PContainer.jsx